module.exports = __webpack_public_path__ + "static/media/print.cc8da97f.svg";